
    import * as React from 'react';

    const Duplicate16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M13.674 12.729v3.214H5.619V2.491h8.055zm-7.282.465v1.936h6.426V3.291H6.394z" /><path d="M2.326 4.264V.058h8.088v1.131H9.61V.861a.6.6 0 0 0-.199-.035L3.2.824V12.69h1.567v.804H2.326z" /></svg>
        </div>
      );
    };

    Duplicate16.displayName = 'Duplicate16';

    export default Duplicate16;
  